/**
 * on click of "submitButton" or "stickySubmitBtn" - popup appears
 * "stickyBar" is declared inorder to hide the sticky bar when popup opens
 * "popupOverlay" div is created to create a blue effect
 * **/

document.addEventListener("DOMContentLoaded", function () {
  const submitButton = document.getElementById("popupButton");
  const stickySubmitBtn =  document.getElementById("stickyPopupButton");
  const stickyBar = document.querySelector('.sticky-add-to-cart-item');

  submitButton?.addEventListener("click", function (event) {
    var checkboxes = document.getElementsByClassName("bundle-checkboxes");
    
    // Loop through all checkboxes and uncheck them
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
    }
    event.preventDefault();
    stickyBar.style.display = "none";
    showPopup();
  });

  stickySubmitBtn?.addEventListener("click", function (event) {
    var checkboxes = document.getElementsByClassName("bundle-checkboxes");
    
    // Loop through all checkboxes and uncheck them
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
    }
    event.preventDefault();
    stickyBar.style.display = "none";
    showPopup();
  });

  const closePopup = document.getElementById("closePopup");
  closePopup.addEventListener("click", hidePopup);
  
  function showPopup() {
    const popUp = document.getElementById("popup");
    const closePopup = document.getElementById("closePopup");
    const body = document.body;
    const popupOverlay = document.querySelector("#popup-overlay");

    if(Array.from(document.querySelectorAll('.metafield_collection_wrapper')).length > 0){
      popUp.style.display = "block";
      body.style.overflow = "hidden"; // Disable scrolling
      popupOverlay.classList.add("blur-background"); 
    }
    else{
      document.getElementById('noThanks').click();
      stickyBar.style.display = "flex"
    }
  }

  function hidePopup() {
    const popUp = document.getElementById("popup");
    const closePopup = document.getElementById("closePopup");
    const body = document.body;
    const popupOverlay = document.querySelector("#popup-overlay");
    
    popUp.style.display = "none";
    body.style.overflow = "auto"; // Enable scrolling 
    popupOverlay.classList.remove("blur-background");
    stickyBar.style.display = "flex"
  }
});